<ng-container *ngIf="!item.children">
  <ng-container *ngIf="item.routerLink">
    <a
      *appFeaturesAuth="{ section: 'MENU', identifier: item.label }; options: features"
      class="list-item large medium left-icon"
      data-toggle="collapse"
      [ngClass]="{ disabled: item.disabled }"
      [routerLink]="item.disabled ? '' : item.routerLink"
      [state]="{ data: item.data }"
      [routerLinkActive]="item.disabled ? '' : item.routerLinkActive"
    >
      <app-sidebar-label
        [item]="item"
        [sidebarActive]="sidebarActive"
        [routerLinkActive]="item.disabled ? '' : item.routerLinkActive"
      ></app-sidebar-label>
    </a>
  </ng-container>

  <ng-container *ngIf="item.link">
    <a
      *appFeaturesAuth="{ section: 'MENU', identifier: item.label }; options: features"
      target="_blank"
      class="list-item large medium left-icon"
      [ngClass]="{ disabled: item.disabled }"
      [href]="item.disabled ? '' : item.link"
    >
      <app-sidebar-label
        [item]="item"
        [sidebarActive]="sidebarActive"
      ></app-sidebar-label>
    </a>
  </ng-container>
</ng-container>

<ng-container *ngIf="item.children && item.children.length > 0">
  <a
    *appFeaturesAuth="{ section: 'MENU', identifier: item.label }; options: features"
    class="list-item large medium right-icon"
    data-toggle="collapse"
    [attr.aria-expanded]="menusExpanded"
    href="#{{ item.routerLink }}"
    [ngClass]="{ disabled: item.disabled }"
  >
    <app-sidebar-label
      [item]="item"
      [sidebarActive]="sidebarActive"
      [id]="item.label.toLowerCase()"
    ></app-sidebar-label>
    <svg class="icon icon-sm icon-primary right mt-1" aria-hidden="true">
      <use xlink:href="assets/svg/sprite.svg#it-expand"></use>
    </svg>
  </a>
  <ul
    class="link-sublist collapse"
    id="{{ item.routerLink }}"
    [ngClass]="{
      show: menusExpanded || isCurrentRoute(item.routerLink),
      disabled: item.disabled
    }"
  >
    <ng-container *ngFor="let child of item.children">
      <li>
        <a
          *appFeaturesAuth="{
            section: 'MENU',
            identifier: child.label
          }; options: features"
          class="list-item"
          [routerLink]="child.disabled ? '' : child.routerLink"
          [state]="{ data: child.data }"
          [ngClass]="{ disabled: item.disabled }"
          (click)="onChildClick(child.routerLink)"
          [routerLinkActive]="child.disabled ? '' : child.routerLinkActive"
        >
          <app-sidebar-label
            [item]="child"
            [sidebarActive]="sidebarActive"
            [routerLinkActive]="item.disabled ? '' : item.routerLinkActive"
            [id]="child.label.toLowerCase() + '-label'"
          ></app-sidebar-label>
        </a>
      </li>
    </ng-container>
  </ul>
</ng-container>
